import { render } from "./ConfirmationModalComponent.vue?vue&type=template&id=1decf6b3"
import script from "./ConfirmationModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__